import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationService } from "./../core/application.service";
import { AppConfig } from '../../models/core/app-config';

@Injectable()
export class LanguageService 
{

    private lang: string = this.translate.currentLang;

    constructor
    (
        private translate: TranslateService,
        private appService: ApplicationService 
    ) {}

    getLongLang(): string 
    {
        switch (this.lang) 
        {
            case 'it': return 'it-IT';
            case 'en': return 'en-GB';
            default: return '';
        }
    }

    getShortLang(): string 
    {
        return this.lang;
    }

    //Return an object containing all the information for the current language (eg. code, lable, icon etc.)
    getCurrentLanguage():any
    {
        let result:LanguageObj = new LanguageObj();

        switch(this.lang)
        {
            case "it": 
        }

        return result;
    }
}

export class LanguageObj
{
    ShortCode: string;
    LongCode: string;
    Text: string;
    IconCode: string;
    ImageUrl: string;
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/language.service.ts